import { render } from "./ecosystemLinks.vue?vue&type=template&id=8587d126&scoped=true"
import script from "./ecosystemLinks.vue?vue&type=script&lang=js"
export * from "./ecosystemLinks.vue?vue&type=script&lang=js"

import "./ecosystemLinks.vue?vue&type=style&index=0&id=8587d126&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8587d126"]])

export default __exports__